import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import boulder__asset from "@/assets/restore/locations/boulder.jpg.asset.json";
import coloradoSprings__asset from "@/assets/restore/locations/colorado-springs.jpg.asset.json";
import downtownDenver__asset from "@/assets/restore/locations/downtown-denver.jpg.asset.json";
import greenwoodVillage__asset from "@/assets/restore/locations/greenwood-village.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Boulder",
    address: "4770 Baseline Rd, Office 232",
    img: boulder__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=4770+Baseline+Rd+Boulder+CO",
    to: "/locations/colorado/boulder/",
  },
  {
    name: "Colorado Springs",
    address: "102 S. Tejon Street, Suite 1100",
    img: coloradoSprings__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=102+S+Tejon+Street+Colorado+Springs+CO",
    to: "/locations/colorado/colorado-springs/",
  },
  {
    name: "Downtown Denver",
    address: "2301 Blake St, Suite 113",
    img: downtownDenver__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=2301+Blake+St+Denver+CO",
    to: "/locations/restore-denver/",
  },
  {
    name: "Greenwood Village",
    address: "5445 DTC Pkwy, Suite 1015",
    img: greenwoodVillage__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=5445+DTC+Pkwy+Greenwood+Village+CO",
    to: "/locations/restore-denver/",
  },
];

export const Route = createFileRoute("/locations/colorado/")({
  head: () => ({
    meta: [
      { title: "Colorado Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Colorado. Find our Boulder, Colorado Springs, Downtown Denver, and Greenwood Village locations for a free hair loss consultation.",
      },
      { property: "og:title", content: "Colorado Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across Colorado and book a free consultation in Boulder, Colorado Springs, Denver, or Greenwood Village.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/colorado/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/colorado/" }],
  }),
  component: () => <StateLocationsHub stateName="Colorado" cities={cities} />,
});